export const TEMPLATE_EDITABLE = {
  text: 0,
  json: 1,
  image: 2,
  bool: 3,
  number: 4
}
